import React, { ComponentProps } from "react";
import { Button } from "@clarkinc/zest-design-system/ui";
import Stars from "~/common/Stars";

interface DetailsProps extends ComponentProps<"div"> {
  thumbnailSrc: string;
  description: string;
  rating: number;
  itemNumber: string;
  handleNavigateToReviews: () => void;
}

const Details = ({
  thumbnailSrc,
  description,
  rating,
  itemNumber,
  handleNavigateToReviews,
}: DetailsProps) => {
  return (
    <div className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap flex">
      <div
        style={{ backgroundImage: `url(${thumbnailSrc})` }}
        className="aspect-square bg-cover bg-center bg-no-repeat w-11 h-11 rounded mr-3"
      />
      <div className="overflow-hidden text-ellipsis whitespace-nowrap pr-6">
        <span
          className="font-semibold text-[20px] leading-5"
          title={description}
        >
          {description}
        </span>
        <div className="flex text-xs">
          {(rating && (
            <Button
              aria-label="see all reviews"
              variant="plain"
              className="scroll-anchor bg-transparent border-0 cursor-pointer p-0 mb-px ml-px"
              onClick={handleNavigateToReviews}
              data-testid="header-see-all-reviews-button"
            >
              <Stars rating={rating} size="small" />
            </Button>
          )) ||
            null}
          <span className="ml-2 text-gray-700">
            ITEM NUMBER: {itemNumber.toUpperCase()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Details;
